import styled from 'styled-components'

export const FlexRowAtom = styled.div<{ $gap?: number }>`
  display: flex;
  gap: ${({ $gap }) => $gap ?? 0}px;
`
